import { Backdrop, CircularProgress } from '@mui/material';

interface SpinnerProps {
  open: boolean;
}

export function Spinner(props: SpinnerProps) {
  return (
    <Backdrop
      open={props.open}
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
